module.exports = __webpack_public_path__ + "media/images/plus-black-84291576bdf2f623c9f0817f98738a96.svg";